<template>
  <transition appear name="fade">
    <div
      class="loading-spinner-block"
      id="loader">
      <v-progress-circular color="white" indeterminate size=100 :width="10">
      </v-progress-circular>
    </div>
  </transition>
</template>

<script>
import {
  mapState,
} from 'vuex';

export default {
  name: 'LoadingSpinner',
  computed: {
    ...mapState([
    ]),
  },
};
</script>

<style lang="scss" scoped>
  #loader {
  position: absolute;
  width:100vw;
  height: 100vh;
  background-color: #212121;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  opacity: 0.2;
  z-index:3;
}
</style>
